// ═══════════════════════════════════════════════════════════════════════════
// WRITTN - Curated First Session Verses
// ═══════════════════════════════════════════════════════════════════════════
// These 7 verses are shown to first-time users to introduce them to
// the breadth and beauty of Scripture. Carefully selected to represent
// different genres, tones, and themes.
// ═══════════════════════════════════════════════════════════════════════════

export const FIRST_SESSION_VERSES = [
    {
        reference: "Psalm 46:10",
        text: "Be still, and know that I am God.",
        book: "Psalms",
        context: "A psalm of trust in God's protection, written during a time of national crisis.",
    },
    {
        reference: "John 1:14",
        text: "The Word became flesh, and lived among us. We saw his glory, such glory as of the only born Son of the Father, full of grace and truth.",
        book: "John",
        context: "The opening of John's Gospel, declaring the incarnation of Christ.",
    },
    {
        reference: "Isaiah 43:1",
        text: "But now this is what the Lord says, he who created you, Jacob, he who formed you, Israel: Do not fear, for I have redeemed you; I have called you by name; you are mine.",
        book: "Isaiah",
        context: "God's promise of restoration to Israel, speaking comfort through the prophet.",
    },
    {
        reference: "Proverbs 3:5-6",
        text: "Trust in the Lord with all your heart, and don't lean on your own understanding. In all your ways acknowledge him, and he will make your paths straight.",
        book: "Proverbs",
        context: "Wisdom literature offering guidance for living faithfully.",
    },
    {
        reference: "Romans 8:38-39",
        text: "For I am persuaded that neither death, nor life, nor angels, nor principalities, nor things present, nor things to come, nor powers, nor height, nor depth, nor any other created thing will be able to separate us from God's love which is in Christ Jesus our Lord.",
        book: "Romans",
        context: "Paul's triumphant declaration of the unbreakable love of God.",
    },
    {
        reference: "Matthew 11:28",
        text: "Come to me, all you who labor and are heavily burdened, and I will give you rest.",
        book: "Matthew",
        context: "Jesus' invitation to the weary, offering himself as the source of rest.",
    },
    {
        reference: "Lamentations 3:22-23",
        text: "It is because of the Lord's loving kindnesses that we are not consumed, because his mercies don't fail. They are new every morning. Great is your faithfulness.",
        book: "Lamentations",
        context: "A moment of hope within a book of grief, affirming God's faithful love.",
    },
];

export default FIRST_SESSION_VERSES;
